import { memo, useEffect, useMemo } from 'react';
import { useStore } from '@/store';
import { PageMode } from '@/store/types';
import styles from './index.module.scss';
import useControl from '@/store/useControl';
import { useXAgentClient } from '@shuwen/wenlv-web-activity-library';
import { IS_XAGENT } from "@/constants/common";



// interface ModeSwitchProps {
//   visible?:boolean;
// }

const ModeSwitch = () => {
  const {set} = useControl();
  const setMode = useStore((state) => state.setMode);
  const setRouteTimeLineDetailId = useStore((state) => state.setRouteTimeLineDetailId);
  const setRouteDetailMode = useStore((state) => state.setRouteDetailMode);
  const toggleDigitalHumanMode = useStore((state) => state.toggleDigitalHumanMode);
  const {xAgentClient,deviceInfo} = useXAgentClient();

  const modes = [
    {  label: '静默',data:{mode:PageMode.SILENT} },
    { label: '首页' ,data:{mode:PageMode.HOME}},
    { label: '大事件',data:{mode:PageMode.EVENT} },
    { label: '地标诗词',data:{mode:PageMode.LANDMARK_POETRY} },
    { label: '人物列表模式',data:{mode:PageMode.ROUTE_CHARACTER_LIST} },
    { label: '主题列表模式',data:{mode:PageMode.ROUTE_THEME_LIST} },
    { label: '人物游线轨迹模式',data:{mode:PageMode.ROUTE_CHARACTER_TRACK} },
    // { label: '钱镠人物轨迹详情',data:{mode:PageMode.ROUTE_CHARACTER_TRACK,card:'详情',tour_id:'4a633e8d-4652-4e77-a1aa-e586c621fbef'} },
    //  { label: '钱镠人物轨迹',data:{mode:PageMode.ROUTE_CHARACTER_TRACK,tour_id:'4a633e8d-4652-4e77-a1aa-e586c621fbef'} },
     { label: '中国作家协会杭州创作之家详情',data:{mode:PageMode.HOME,card:'详情',location_id:'f55da6b7-7656-46da-9343-bed2a2f13624',location:'中国作家协会杭州创作之家'} },
     { label: '国际青春诗会大事件',data:{mode:PageMode.EVENT,event_id:'3bfeea6d-8c23-4be4-ad88-6ff10164a832',event:'国际青春诗会'} },
     { label: '孤山有哪些诗人',data:{mode:PageMode.LANDMARK_POETRY,card:'诗人',location_id:'d392af3e-fa62-4d96-a732-cc082c42395b',location:'孤山'} },
     { label: '孤山有哪些诗词',data:{mode:PageMode.LANDMARK_POETRY,card:'诗词',location_id:'d392af3e-fa62-4d96-a732-cc082c42395b',location:'孤山'} },
     { label: '弘历在孤山',data:{mode:PageMode.LANDMARK_POETRY,card:'诗词',location_id:'d392af3e-fa62-4d96-a732-cc082c42395b',location:'孤山',person:'弘历'} },
     { label: '巴金人物轨迹',data:{mode:PageMode.ROUTE_CHARACTER_TRACK,tour_id:'72aa8351-7431-42b3-b71b-c4926f4ef7d9',person:'巴金'} },
    // { key: PageMode.ROUTE_CHARACTER_TRACK_SINGLE, label: '人物轨迹模式' },
  ];

  useEffect(() => {
    // console.log('xAgentClient',xAgentClient);
    xAgentClient?.socket?.on('send-to-client', (message) => {
      console.log('view_reciiveMsg:', message);
      if(message.type==='xihucitywalk'){
        set(message.data);
      }
    })
  }, []);


  const visible = useMemo(() => {
    const isShow = deviceInfo?.exhibitionConfigInfo?.isShowModeSwitch;
    return !IS_XAGENT||isShow;
  }, [deviceInfo]);

  return visible&&(
    <div className={styles.modeSwitch}>
      {/* <button
        className={styles.button}
        onClick={() => toggleDigitalHumanMode()}
      >
        数字人
      </button>
      */}
      {modes.map(({label,data }) => (
        <button
          key={label}
          className={styles.button}
          onClick={() => {
            set(data);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default memo(ModeSwitch); 
